import { I18nComponente } from "@/types/gerais"

export const OTabelaDestravarPeriodoi18n: I18nComponente = {
  "pt-BR": {
    projetosTravados: "projetos travados",
    primeiroDiaDestravado: "primeiro dia destravado",
    periodoDestravadoComSucesso: "Período destravado com sucesso",
    naoFoiPossivelDestravarPeriodo: "Não foi possível destravar o período",
    salvarAlteracoes: "salvar alterações"
  },
  "es-CO": {
    projetosTravados: "proyectos bloqueados",
    primeiroDiaDestravado: "primer día desbloqueado",
    periodoDestravadoComSucesso: "Período desbloqueado exitosamente",
    naoFoiPossivelDestravarPeriodo: "No se pudo descongelar el período",
    salvarAlteracoes: "guardar cambios"
  }
}
